import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/buttons/Button';
import { DialogContent } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { useStores } from '../../../../../stores/useStores';
import type { SofWizardStepFactory } from '../../types';

import checkMark from './checkMark.svg';
import styles from './SofProcessView.module.scss';

export const sofSuccessViewFactory: SofWizardStepFactory = () => {
  return observer(function SofSuccessView() {
    const { t } = useTranslation();
    const { portalStore } = useStores();

    return (
      <DialogContent className={styles.content}>
        <p className={styles.pseudoTitle}>{t('sof.verificationCompletedTitle')}</p>
        <p className={styles.text}>{t('sof.verificationCompletedDesc')}</p>
        <img alt="check mark" className={styles.image} src={checkMark} />
        <Button btnType="main" onClick={() => portalStore.closePortal()}>
          {t('buttons.great')}
        </Button>
      </DialogContent>
    );
  });
};
